import { withoutInsurancePremium } from '../../supabase/functions/_shared/trip-insurance.js';

/**
 * One row of /api/investor/pitch-data in the camelCase shape the Investor
 * Pitch page reads (the same mapping the FlightBooking constructor does).
 *
 * Every pitch figure is traction: GMV, fees, average fare. A Faye travel
 * insurance premium rides inside a booking's totals (migration 156) but is
 * collected for Faye, so it is taken out here, once, before any of them is
 * computed. A booking without a premium maps exactly as before.
 */
export function normalizePitchBooking(raw) {
  const b = withoutInsurancePremium(raw || {});
  let fd = b.flight_data;
  if (typeof fd === 'string') { try { fd = JSON.parse(fd); } catch { fd = {}; } }
  fd = (fd && typeof fd === 'object' && !Array.isArray(fd)) ? fd : {};
  return {
    id: b.id,
    userId: b.user_id,
    user_id: b.user_id,
    createdAt: b.created_at,
    created_at: b.created_at,
    status: b.status,
    totalPrice: b.total_amount ?? fd?.totalPrice ?? 0,
    total_amount: b.total_amount ?? 0,
    service_fee: b.service_fee ?? fd?.serviceFee ?? 0,
    serviceFee: b.service_fee ?? fd?.serviceFee ?? 0,
    hold_fee: b.hold_fee ?? fd?.holdFee ?? null,
    grand_total: b.grand_total ?? fd?.grandTotal ?? null,
    grand_total_with_hold: b.grand_total_with_hold ?? fd?.grand_total_with_hold ?? null,
    payment_method: fd?._payment_method || null,
    flight_data: fd,
    flightData: fd,
  };
}
